import { Component, Input, Output, ViewChild, EventEmitter, OnInit, OnChanges, AfterViewChecked, ViewChildren } from "@angular/core";
import { CronOptions } from "../../insa-cron-assets/CronOptions";
import { InsaCronService, AuthService } from "../../../../insa-services";
import { InsaChronosJobModel, ChronosActivitiesModel, ChronosActivityResultActions } from '../../../../insa-models';
import { resolve } from "path";
import * as mermaid from "mermaid";
import { saveSvgAsPng } from "save-svg-as-png";
import { Subject } from "rxjs";

const anime = require('animejs/lib/anime.js');

@Component({
    selector: "edit-job",
    template: require("./edit-job.component.html"),
    styles: [require("./edit-job.component.css").toString()]
})

export class EditJobComponent implements OnInit {

    @Input() selectedJobData: InsaChronosJobModel = new InsaChronosJobModel();
    @Input() jobsList = new Array<InsaChronosJobModel>();

    @Output() emitIsComponentCreated: EventEmitter<any> = new EventEmitter<any>(true);

    //Mermaid
    @ViewChild("mermaid", { static: false })
    public mermaidDiv;
    @Output() chartActivityIDSubject: Subject<number> = new Subject();
    @Output() chartTriggerAddNewSubject: Subject<boolean> = new Subject();

    private jobData: InsaChronosJobModel = new InsaChronosJobModel();
    private submitted: boolean = false;
    private newActivity: any;
    private postActions: any;
    private jobNameStatus: string = "Job name";
    private jobUpdateStatus: boolean = false;
    private jobDuplicate: boolean = false;
    private jobActivities: any; //  Array<ChronosActivitiesModel> = new Array <ChronosActivitiesModel>(); holi
    private activityPostActions: any; //    Array<ChronosActivityResultActions>; holi
    private prioritiesList: any;
    private graphString: string;
    private prioritiesListFetched: boolean = false;
    private postActivitiesFetched: boolean = false;
    private loadingSvgToPng: boolean = false;
    private statusOverlay: boolean = false;
    private renderOnSaveGraph: boolean;
    private deleteAndUpdateGraph: boolean;
    private jobTitleOnPng: boolean = false;
    private activityTypes: any;

    constructor(private _insaChronService: InsaCronService, private _authService: AuthService) { }

    public cronExpression = "0 3 2 12 1/1 ? *";
    public isCronDisabled = false;
    public cronOptions: CronOptions = {
        formInputClass: 'form-control cron-editor-input',
        formSelectClass: 'form-control cron-editor-select',
        formRadioClass: 'cron-editor-radio',
        formCheckboxClass: 'cron-editor-checkbox',
        defaultTime: "10:00:00",
        hideMinutesTab: false,
        hideHourlyTab: false,
        hideDailyTab: false,
        hideWeeklyTab: false,
        hideMonthlyTab: false,
        hideYearlyTab: false,
        hideAdvancedTab: false,
        hideLogTableTab: true,
        hideChronosJobTableTab: true,
        hideTaskListTab: true,
        use24HourTime: false,
        hideSeconds: false,

    };

    getActivity(newActivity) {
        this.newActivity = newActivity;
    }

    getPostActions(postActions) {
        this.postActions = postActions;
    }

    cancelJob() {
        this.emitIsComponentCreated.emit(false);
    }

    onSubmit(editedJob: any) {
        if (editedJob.invalid || editedJob == undefined) {
            return;
        }
        this.submitted = true;
        this.jobUpdateStatus = false;
        this.jobData.JobID = editedJob.JobID;
        this.jobData.CRONExpression = editedJob.CRONExpression;
        this.jobData.Description = editedJob.Description;
        this.jobData.Name = editedJob.Name;
        this.jobData.Activities = [];
        this.jobData.Activities = this.newActivity;
        this.jobData.JobLastModifiedBy = this._authService.UserInfo.Name;

        let duplicateJob = this.jobsList.find(jl => jl.Name === editedJob.Name);
        if ((duplicateJob != null && duplicateJob != undefined) && duplicateJob.JobID != editedJob.JobID) {
            if (duplicateJob.JobID != editedJob.JobID) {
                this.jobDuplicate = true;
            } else {
                this._insaChronService.updateJob(this.jobData).subscribe();
                this.jobUpdateStatus = true;
                window.scrollBy(0, -200);
                setTimeout(() => {
                    this.emitIsComponentCreated.emit(false);
                }, 2000);
            }
        } else {
            if (editedJob.JobID != null && editedJob.JobID != undefined) {
                this._insaChronService.updateJob(this.jobData).subscribe();
                this.jobUpdateStatus = true;
                window.scrollBy(0, -200);
                setTimeout(() => {
                    this.emitIsComponentCreated.emit(false);
                }, 2000);
            } else {
                this.jobUpdateStatus = false;
                this._insaChronService.addJob(this.jobData).subscribe();
                this.emitIsComponentCreated.emit(false);
            }
        }
    }

    checkJobName() {
        this.jobDuplicate = false;
    }

    /*onUpdate(editedJob: any) {
    }*/

    mermaidUpdateGraph(graphDefinition: string) {
        mermaid.initialize({
            flowchart: {
                curve: 'basis',
                useMaxWidth: false,
                cloneCssStyles: true,
                height: '1000',
                htmlLabels: true
            }
        });
       
        //Define element for #graphDiv svg to render
        const element = this.mermaidDiv.nativeElement;

        //const element = document.querySelector('#mermaid');
        mermaid.render("graphDiv", graphDefinition, (svgCode, bindFunctions) => {
            element.innerHTML = svgCode;
            //Add mermaid graph events
            this.mermaidEvents();
        }, element);
    }

    getActivites() {
        this.prioritiesListFetched = false;
        this.postActivitiesFetched = false;
        this.jobActivities = undefined;
        this._insaChronService.getPriorities().subscribe(priorities => {
            this.prioritiesList = priorities;
            this.prioritiesListFetched = true;
            //init mermaid after all data fetched
            this.initMermaid();
        });

        this._insaChronService.getActivityType().subscribe(data => {
            this.activityTypes = data;
        });

        if (this.selectedJobData.JobID !== null && this.selectedJobData.JobID !== undefined) {
            //Get all data for Mermaid
            this._insaChronService.getActivityByJobId(this.selectedJobData.JobID).subscribe(res => {
                this.jobActivities = res;
                this.initMermaid();
            });

            this._insaChronService.getAllPostaActions(this.selectedJobData.JobID).subscribe(res => {
                this.activityPostActions = res;
                this.postActivitiesFetched = true;
                //init mermaid after all data fetched
                this.initMermaid();
            });
        }
    }


    initMermaid() {
        if (!this.prioritiesListFetched || !this.postActivitiesFetched) return;
        if (!this.jobActivities || this.jobActivities.length < 1) return;

        // Show or hide loading spinner 
        if (this.activityPostActions.length < 1) {
            //Loading spinner
            this.loadingSvgToPng = false;
        } else {
            this.loadingSvgToPng = true;
        }

        //Mermaid data
        let activityString: string = "";
        let activityRelationsString: string = "";
        let taskColor: string = "";

        //for (let i = 0; i < this.jobActivities.length; i++) {
        for (const act of this.jobActivities) {

            //Icons logic 
            let taskIcon: string = "";
            if (act.ActivityTypeID == 2) {
                taskIcon = `fa:fa-bug`;
                taskColor += `style ${act.ActivityID} fill:#ccb4bf;\r\n`;
            }
            else if (act.ActivityTypeID == 3) {
                taskIcon = `fa:fa-university`;
                taskColor += `style ${act.ActivityID} fill:#eee;\r\n`;
            }
            else if (act.ActivityTypeID == 5) {
                taskIcon = `fa:fa-upload`;
                taskColor += `style ${act.ActivityID} fill:#b3c7cc;\r\n`;
            }
            //width:20px fill:#222222
            else if (act.ActivityTypeID == 6) {
                taskIcon = 'fa:fa-cogs';
                taskColor += `style ${act.ActivityID} fill:#eee;\r\n`;
            }
            else if (act.ActivityTypeID == 7) {
                taskIcon = `fa:fa-envelope`;

                taskColor += `style ${act.ActivityID} fill:#EEF;\r\n`;
            }
            else if (act.ActivityTypeID == 8) {
                taskIcon = `fa:fa-envelope-o`;
                taskColor += `style ${act.ActivityID} fill:#EEF;\r\n`;
            }
            else if (act.ActivityTypeID == 9) {
                taskIcon = `fa:fa-sms`;
                taskColor += `style ${act.ActivityID} fill:#EEF;\r\n`;
            }
            else if (act.ActivityTypeID == 10) {
                taskIcon = `fa:fa-university`;
                taskColor += `style ${act.ActivityID} fill:#b4ccb7;\r\n`;
            }
            else {
                taskIcon = 'fa:fa-cog';
                taskColor += `style ${act.ActivityID} fill:#FEE;`;
            }

            //Activity string description for lines
            activityString += act.ActivityID + "(" + `${taskIcon} ` + act.Description + ")\r\n";
        }

        if (this.activityPostActions !== undefined) {
            for (let i = 0; i < this.activityPostActions.length; i++) {
                for (const iterator of this.prioritiesList) {
                    if (iterator.PriorityID == this.activityPostActions[i].PriorityID) {
                        activityRelationsString += this.activityPostActions[i].ActivityID + "--" + iterator.Description1 + "-->" + this.activityPostActions[i].PostActivityID + "  \r\n";
                    }
                }
            }
        }

        //Graph static Data and style
        // const styles = {
        //     display: "flex",
        //     flexWrap: "wrap",
        //     alignItems: "center",
        //     fontFamily: "sans-serif",
        //     justifyContent: "space-between"
        //   };
        // const graphEnd = `\r\nEND((fa:fa-plus))`;
        // const graphPrint = `PRINT((fa:fa-cloud-download-alt))`;
        // const closeGraphBtn = `CLOSE((fa:fa-times))`;

        // let addActivityBtn = () => {
        //     return `${graphEnd}; 
        //             style END fill:#a3dbff, stroke:#00e676, width:5px, position:absolute;  
        //             class END mermaidAddActBtn;`
        // }

        // let printBtn = () => {
        //     return `${graphPrint};
        //             style PRINT stroke:#ff2e00, width:5px, position:absolute;  
        //             class PRINT mermaidPrintBtn;`

        // }

        // let closeGraph = () => {
        //     return `${closeGraphBtn};
        //             style END fill:#a3dbff, stroke:#00e676;  
        //             class END mermaidCloseBtn;`
        // }

        //Generate Mermaid graph string
        this.graphString = `graph TD; ${activityString}${activityRelationsString}${taskColor}`;
        this.mermaidUpdateGraph(this.graphString);

        //Animate graph activity lines using anime.js
        anime({
            targets: '.edgePath path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1500,
            delay: function (el, i) { return i * 250 },
            direction: 'alternate',
            loop: false
        });

        this.jobActivities.forEach(el => {
            if (document.getElementById(`${el.ActivityID}`) == null && document.getElementById(`${el.ActivityID}`) == undefined) {
                return;
            } else {
                //Add click event for each graph activity element
                return document.getElementById(`${el.ActivityID}`).addEventListener(`click`, (e) => {
                    let parentNode = e.target["parentNode"];
                    //Fix for clicking outside of el.Activity element
                    if (!parentNode.id) {
                        let node = parentNode;
                        node = node.parentNode;
                        node = node.parentNode;
                        node = node.parentNode.id;
                        this.chartActivityIDSubject.next(node);
                    } else {
                        this.chartActivityIDSubject.next(parentNode.id);
                    }
                });
            }
        });
        //Remove loading spinner
        this.loadingSvgToPng = false;
    }

    mermaidEvents() {

        // let mermaidCloseGraph =  document.querySelector('#CLOSE') as HTMLElement;
        let body = document.querySelector('#wrapper') as HTMLElement;
        // let removePrintIcon = document.querySelector('.mermaidPrintBtn') as HTMLElement;
        //let addBtn = document.querySelector('.mermaidAddActBtn') as HTMLElement;
        let mermaidOpenGraph = document.querySelector('.mermaidOpenGraph') as HTMLElement;



        //Remove for graph image
        // mermaidCloseGraph.style.visibility = "hidden";

        //Print event from svg to png image

    }

    renderMermaidOnSave(data) {
        this.renderOnSaveGraph = data;
        if (this.renderOnSaveGraph == true) {
            this.getActivites();
        } else {
            return;
        }
    }

    deleteAndUpdate(data) {
        this.deleteAndUpdateGraph = data;
        if (this.deleteAndUpdateGraph == true) {
            this.getActivites();
        } else {
            return;
        }
    }

    ngOnInit() {
        this.getActivites();
    }

}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-form/edit-job.component.ts